/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of the ingestion pipeline
*/
export enum IngestionPipelineStatus {
  INGESTION_PIPELINE_STATUS_CREATING = 'CREATING',
  INGESTION_PIPELINE_STATUS_CREATE_FAILED = 'CREATE_FAILED',
  INGESTION_PIPELINE_STATUS_STOPPED = 'STOPPED',
  INGESTION_PIPELINE_STATUS_STARTING = 'STARTING',
  INGESTION_PIPELINE_STATUS_STARTED = 'STARTED',
  INGESTION_PIPELINE_STATUS_STOPPING = 'STOPPING',
  INGESTION_PIPELINE_STATUS_DELETING = 'DELETING'
}
